export enum ShiftState {
  active = 0,
  closed = 1,
  expired = 2,
}
